import { Badge, Box, Flex, Heading, Text, useSlotRecipe } from '@chakra-ui/react';

import { SeoLinksProps } from './seo-links.props';

export const SeoLinks = ({ title, linkSections, classNames, ...props }: SeoLinksProps) => {
    const recipe = useSlotRecipe({ key: 'seoLinks' });
    const styles = recipe();

    if (!linkSections?.length) {
        return;
    }
    return (
        <Box {...props} data-testid={'seo-links'}>
            {title ? (
                <Heading as={'h2'} size="lg" css={styles.heading} data-testid={'seo-links-header'}>
                    {title}
                </Heading>
            ) : null}
            {linkSections.map((section, index) => {
                return section?.tags?.length ? (
                    <Box
                        key={index}
                        css={styles.seoLinksSection}
                        data-testid={`seo-links-section-${index}`}
                        className={classNames?.section}
                    >
                        <Text
                            css={styles.seoLinksSectionTitle}
                            data-testid={`seo-links-section-title-${index}`}
                            className={classNames?.sectionTitle}
                        >
                            {section.title}
                        </Text>
                        <Flex css={styles.tagsWrapper} className={classNames?.list}>
                            {section.tags.map((tag, tagIndex) => {
                                return (
                                    <Badge
                                        asChild
                                        key={tagIndex}
                                        css={styles.tagBadge}
                                        size={'sm'}
                                        fontWeight={'normal'}
                                        data-testid={`seo-link-${index}-${tagIndex}`}
                                        className={classNames?.link}
                                    >
                                        <a href={tag.url}>{tag.name}</a>
                                    </Badge>
                                );
                            })}
                        </Flex>
                    </Box>
                ) : null;
            })}
        </Box>
    );
};
